import { defineStore } from 'pinia'
import type { CasinoItemGame } from '~/composables/casino/interface'

export interface CasinoState {
  providers: Set<string>
  categories: Set<string>
  mainGames: CasinoItemGame[]
  indirectGames: CasinoItemGame[]
}
const STORE_NAME = 'casinoStore'

export const useCasinoStore = defineStore(STORE_NAME, {
  state: (): CasinoState => ({
    providers: new Set(),
    categories: new Set(),
    mainGames: [],
    indirectGames: [],
  }),
  persist: false,
  actions: {
    setCasinoStore({ providers, categories, mainGames, indirectGames }: CasinoState) {
      this.providers = providers
      this.categories = categories
      this.mainGames = mainGames
      this.indirectGames = indirectGames
    },
    getCasinoStore(): CasinoState {
      return {
        providers: this.providers,
        categories: this.categories,
        mainGames: this.mainGames,
        indirectGames: this.indirectGames
      }
    }
  }
})
